<div class="card card-custom gutter-b" id="create_role_form">
  <div class="card-body col-lg-6 col-12 create-card">
    <kt-auth-notice class="my-5"></kt-auth-notice>
    <div class="mt-5 pt-5">
      <h1>Reset Password</h1>
      <p class="text-muted font-weight-bold">Set a strong password to secure your account</p>
    </div>
    <form class="form" [formGroup]="changePasswordForm" autocomplete="off" *ngIf="changePasswordForm">
      <div class="form-group">
        <label class="form-label required">Current Password</label>
        <input
          type="password"
          class="form-control custom"
          placeholder="Current Password"
          required
          formControlName="current_password"
          autocomplete="current-password"
          sflPasswordEye
        />
        <small *ngIf="isControlHasError(changePasswordForm, 'current_password', 'required')" class="form-text text-danger">Current Password is required</small>
        <small *ngIf="isControlHasError(changePasswordForm, 'current_password', 'server')" class="form-text text-danger"
          >Current Password {{ changePasswordForm.get('current_password')?.errors?.server }}</small
        >
      </div>

      <div class="form-group">
        <label class="form-label required">New Password</label>
        <input type="password" class="form-control custom" placeholder="New Password" required formControlName="password" autocomplete="new-password" sflPasswordEye />
        <small *ngIf="isControlHasError(changePasswordForm, 'password', 'required')" class="form-text text-danger">New Password is required</small>
        <small *ngIf="isControlHasError(changePasswordForm, 'password', 'minlength')" class="form-text text-danger">Password must be at least 8 characters</small>
        <small *ngIf="isControlHasError(changePasswordForm, 'password', 'maxlength')" class="form-text text-danger">Password cannot exceed 100 characters</small>
        <small *ngIf="isControlHasError(changePasswordForm, 'password', 'server')" class="form-text text-danger"
          >New Password {{ changePasswordForm.get('password')?.errors?.server }}</small
        >
      </div>

      <div class="form-group">
        <label class="form-label required">Confirm Password</label>
        <input
          type="password"
          class="form-control custom"
          placeholder="Confirm Password"
          required
          formControlName="password_confirmation"
          autocomplete="new-password"
          sflPasswordEye
        />
        <small *ngIf="isControlHasError(changePasswordForm, 'password_confirmation', 'required')" class="form-text text-danger">Confirm Password is required</small>
        <small *ngIf="isControlHasError(changePasswordForm, 'password_confirmation', 'minlength')" class="form-text text-danger">Password must be at least 8 characters</small>
        <small *ngIf="isControlHasError(changePasswordForm, 'password_confirmation', 'maxlength')" class="form-text text-danger">Password cannot exceed 100 characters</small>
        <small *ngIf="isControlHasError(changePasswordForm, 'password_confirmation', 'server')" class="form-text text-danger"
          >Confirm Password {{ changePasswordForm.get('password_confirmation')?.errors?.server }}</small
        >
        <small *ngIf="changePasswordForm?.errors?.passwordNotMatch" class="form-text text-danger">Passwords do not match</small>
      </div>

      <!--begin::Action-->
      <div class="form-group d-flex flex-wrap justify-content-end">
        <button (click)="submit()" class="btn btn-primary font-weight-bold w-100" [isSubmitting]="isSubmitting" [disabled]="changePasswordForm.invalid">Change Password</button>
      </div>
      <!--end::Action-->
    </form>
  </div>
  <!--end::Change Password-->
</div>
<!--end::Body-->
